import { render, staticRenderFns } from "./SubmissionTissueReport.vue?vue&type=template&id=07daceea"
import script from "./SubmissionTissueReport.vue?vue&type=script&lang=js"
export * from "./SubmissionTissueReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports